<template>
  <div class="pagination">
    <span class="current">{{currentStep-1}}</span> &horbar; <span class="total">5</span>
  </div>
</template>

<script>
  export default {
    name: 'LCPagination',
    props: {
      currentStep: {
        type: Number,
        default: undefined
      }
    },
  }
</script>

<style lang="scss" scoped>
.pagination {
  position: fixed;
  right: 50px;
  top: 39px;
  font-size: 12px;
  color: rgba(255,255,255,0.4);
  z-index: 1;


  .current,
  .total {
    display: inline-block;
  }

  .current {
    font-weight: bold;
    color: #FFD1AD;
    margin-right: 6px;
  }

  .total {
    margin-left: 6px;
  }
}
</style>
